// Turbolinks keeps the users's scroll position even on pages that it shouldn't
// This may be due to changes in <head> or other issues listed in the issue below:
// https://github.com/turbolinks/turbolinks/issues/181#issuecomment-426869211

import ScrollPositionHelper from 'lib/scroll-position-helpers';
import StickyScrollPositionHelper from 'lib/sticky-scroll-position-helpers';

const applyTurbolinksScrollPatch = () => {
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }

  window.EezyScrollPositionHelper = ScrollPositionHelper;
  window.EezyStickyScrollPositionHelper = StickyScrollPositionHelper;

  window.addEventListener('turbolinks:load', () => {
    window.EezyScrollPositionHelper.setScrollPosition();
  });
};

export default applyTurbolinksScrollPatch;
